export default __webpack_public_path__ + "static/media/barista2.fc26ce30.jpg";